import { Button } from '@/components/ui/Button';

/**
 * First card a visitor sees in guest-browse mode, shown over the blurred
 * library before the reading-level selector. Sets expectations: browse now,
 * create an account / add readers later. Mirrors the iOS `GuestWelcomeView`.
 */
export function GuestWelcomeCard({ onContinue }: { onContinue: () => void }) {
  return (
    <div className="rounded-[28px] border border-white/60 bg-white p-8 text-center shadow-or-pop">
      <img
        src="/brand/ollie_logo_square.png"
        alt=""
        width={88}
        height={88}
        className="mx-auto rounded-2xl shadow-or-card"
      />
      <h1 className="mt-5 font-display text-[28px] font-bold leading-tight text-or-slate-900">
        Welcome to OllieReads
      </h1>
      <p className="mt-3 text-[15px] leading-relaxed text-or-slate-600">
        Jump right in and explore. Select reading level(s) on the next screen to get started. You
        can add readers and log in or create an account later, when you&rsquo;re ready.
      </p>
      <div className="mt-6">
        <Button size="lg" onClick={onContinue} className="w-full">
          Get started
        </Button>
      </div>
    </div>
  );
}
